// @flow
import * as React from 'react';
import styles from "./floating-label-input.scss";

type State = {
  focus: bool
};

type Defaults = {
  id: string,
  label: string,
  errorMessage: string
}

export default class FloatingLabelInput extends React.Component<*, State> {
  static defaultProps: Defaults;

  constructor(props: *) {
    super(props);

    this.state = {
      focus: false
    };

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  onBlur: Function;
  onBlur() {
    this.setState((prevState, props) => {
      return {
        focus: false
      };
    });
  }

  blurBuilder(blur: ?Function) {
    return (e: *) => {
      this.onBlur();

      if (blur) {
        return blur(e);
      }
    }
  }

  onFocus: Function;
  onFocus() {
    this.setState((prevState, props) => {
      return {
        focus: true
      };
    });
  }

  focusBuilder(focus: ?Function) {
    return (e: *) => {
      this.onFocus();

      if (focus) {
        return focus(e);
      }
    }
  }

  render() {
    let { id, label, children, focus, filled, error, errorMessage } = this.props;

    let extChild = React.Children.map(this.props.children, child => {
      let { onBlur, onFocus } = child.props;

      // Extend anything existing that is bound to the focus and blur calls
      // to be able to support automatic blur and focus transitioning of error
      // messages
      return React.cloneElement(child, {
        onBlur: this.blurBuilder(onBlur),
        onFocus: this.focusBuilder(onFocus)
      });
    });

    // Default to the single child case and try to extract an id
    if (!id && children && children.props && children.props.id) {
      id = children.props.id;
    }

    // Default to the single child case and try to extract the placeholder to
    // use as the label if one is not provided
    if (!label && children && children.props && children.props.placeholder) {
      label = children.props.placeholder;
    }

    let isFocused = typeof focus !== 'undefined' ? focus : this.state.focus;
    let focusClass = isFocused ? 'focus' : 'no-focus';
    let filledClass = typeof filled !== 'undefined' && filled && 'filled' || '';
    let errorClass = !isFocused && !!error ? 'error' : '';
    let displayErrorMessage = !isFocused && error && errorMessage;

    return (
      <React.Fragment>
        <div className={`floating-field ${focusClass} ${filledClass} ${errorClass}`}>
          {extChild}
          <label htmlFor={id}>
            {label}
          </label>
        </div>
        {displayErrorMessage && <div className="error-text">{errorMessage}</div>}
      </React.Fragment>
    );
  }
}

FloatingLabelInput.defaultProps = {
  id: "",
  label: "",
  errorMessage: ""
};